import { MoonStarIcon } from '@examdojo/core/tiptap-react-ui-components/components/tiptap-icons/moon-star-icon';
import { SunIcon } from '@examdojo/core/tiptap-react-ui-components/components/tiptap-icons/sun-icon';
import { Button } from '@examdojo/core/tiptap-react-ui-components/components/tiptap-ui-primitive/button';
import { useEffect, useState } from 'react';

export function ThemeToggle() {
  const [isDarkMode, setIsDarkMode] = useState<boolean>(() => document.documentElement.classList.contains('dark'));

  useEffect(() => {
    document.documentElement.classList.toggle('dark', isDarkMode);
  }, [isDarkMode]);

  const toggleDarkMode = () => setIsDarkMode((isDark) => !isDark);

  return (
    <Button onClick={toggleDarkMode} aria-label={`Switch to ${isDarkMode ? 'light' : 'dark'} mode`} data-style="ghost">
      {isDarkMode ? <MoonStarIcon className="tiptap-button-icon" /> : <SunIcon className="tiptap-button-icon" />}
    </Button>
  );
}
